export default __webpack_public_path__ + "static/media/marker.43015272.svg";